{
  "common": {
    "appName": "Qahvadosh Admin",
    "loading": "Loading…",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "apply": "Apply",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "actions": "Actions",
    "details": "Details",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "all": "All",
    "from": "from",
    "to": "to",
    "sum": "UZS",
    "coffee": "coffee",
    "coffeeCount": "{{count}} coffee",
    "theme": "Appearance",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "language": "Language",
    "logout": "Log out",
    "copy": "Copy",
    "copied": "Copied",
    "never": "Never",
    "today": "Today",
    "week": "Week",
    "month": "Month",
    "quarter": "Quarter",
    "minutesShort": "{{count}} min",
    "duration": "Duration",
    "edit": "Edit",
    "delete": "Delete",
    "logoutTitle": "Sign out?",
    "logoutBody": "The session closes and you go back to the site. Returning to the panel means signing in again.",
    "back": "Back",
    "day": "Day",
    "year": "Year"
  },
  "nav": {
    "dashboard": "Statistics",
    "analytics": "Analytics",
    "users": "Users",
    "invitations": "Invitations",
    "ledger": "Ledger",
    "payments": "Payments",
    "withdrawals": "Withdrawals",
    "reports": "Reports",
    "hostApplications": "Host applications",
    "settings": "Settings",
    "openMenu": "Open menu",
    "roles": "Roles",
    "reference": "Reference data",
    "referenceIndustries": "Industries",
    "referenceRegions": "Regions",
    "referenceDistricts": "Districts",
    "finance": "Money",
    "settingsPlatform": "Platform",
    "settingsMeetings": "Meetings",
    "audit": "Audit log",
    "promo": "Promo codes",
    "payouts": "Payout profiles",
    "live": "Live",
    "reviews": "Reviews",
    "messages": "Messages"
  },
  "auth": {
    "checking": "Checking your session…",
    "signInRequired": "Sign-in required",
    "signInHint": "To open the admin panel, sign in with Telegram on the main site. The session works on both.",
    "goToLogin": "Go to sign-in",
    "stepOne": "Sign in with Telegram on the main site",
    "stepTwo": "Come back to this page once it is confirmed",
    "stepThree": "The panel opens automatically",
    "sessionNote": "No password: the session lives in a secure cookie and works on both sites.",
    "backToSite": "Back to the site",
    "networkHint": "The server is not responding. Check your connection and try again.",
    "retry": "Try again",
    "forbiddenTitle": "No access",
    "forbiddenHint": "You do not have permission for this section. Ask the system owner for a suitable role if you need it.",
    "role": "Role",
    "superadmin": "Superadmin",
    "permissionCount": "{{count}} permissions"
  },
  "dashboard": {
    "title": "Statistics",
    "subtitle": "Confirmed meetings are the north star. Sign-ups are not.",
    "period": "Period",
    "confirmedMeetings": "Confirmed meetings",
    "activeHosts": "Active hosts",
    "acceptRate": "Invitation → accepted",
    "confirmRate": "Accepted → confirmed",
    "medianResponse": "Response time (median)",
    "repeatGuests": "Repeat guests",
    "internalCirculation": "Internal circulation",
    "disputeRate": "Dispute rate",
    "revenue": "Platform revenue",
    "target": "Target: {{value}}",
    "hours": "{{count}} h",
    "funnelTitle": "Funnel",
    "funnelSignup": "Signed up",
    "funnelProfile": "Completed profile",
    "funnelSearch": "Searched",
    "funnelInvited": "Sent an invitation",
    "funnelAccepted": "Accepted",
    "funnelConfirmed": "Confirmed",
    "meetingsChart": "Meetings per week",
    "statusChart": "Invitations by status",
    "empty": "No data for this period",
    "rangeHint": "{{from}} — {{to}}. Compared with {{comparedFrom}} — {{comparedTo}}.",
    "previousWas": "Previous period: {{value}}",
    "sectionCore": "Core metrics",
    "sectionUsers": "Users",
    "sectionMoney": "Coffee and money",
    "invitationsSent": "Invitations sent",
    "accepted": "Accepted",
    "ofHosts": "Of {{value}} hosts",
    "newUsers": "New users",
    "totalUsers": "Total users",
    "activeUsers": "Active in period: {{value}}",
    "hosts": "Hosts",
    "newHosts": "New in period: {{value}}",
    "blockedUsers": "Blocked",
    "deletedUsers": "Deleted: {{value}}",
    "payments": "Payments",
    "payouts": "Payouts",
    "paymentCount": "{{count}} payments · {{coffees}} sold",
    "pendingPayout": "Pending: {{value}}",
    "liability": "Refund reserve",
    "liabilityHint": "Unspent coffee at {{price}} — an upper bound",
    "revenueHint": "The sales themselves — the money does not go back anywhere",
    "coffeesPurchased": "Coffee purchased",
    "coffeesWithdrawn": "Coffee withdrawn",
    "spentOnMeetings": "On meetings: {{value}}",
    "circulating": "Coffee in circulation",
    "circulatingHint": "Held {{held}}, maturing {{maturing}}",
    "avgRating": "Average rating",
    "reviewCount": "{{count}} ratings",
    "meetingsCount": "{{count}} meetings",
    "minutes": "{{count}} minutes",
    "queueTitle": "Needs attention",
    "queueEmpty": "Nothing is waiting right now.",
    "oldest": "oldest {{value}}",
    "queue": {
      "negativeBalances": "Users with a negative balance",
      "openDisputes": "Open disputes",
      "pendingWithdrawals": "Unpaid withdrawal requests",
      "stuckPayments": "Stuck payments",
      "expiringSoon": "Invitations expiring soon",
      "pendingInvitations": "Invitations awaiting an answer",
      "blockedUsers": "Blocked users",
      "unverifiedHosts": "Unverified hosts"
    },
    "moneyChart": "Money flow",
    "topHosts": "Most active hosts",
    "topGuests": "Most active guests",
    "topRated": "By rating",
    "notEnoughRatings": "Not enough ratings yet",
    "providersTitle": "Payment providers",
    "formatsTitle": "Format and duration",
    "regionsTitle": "Regions",
    "industriesTitle": "Industries",
    "providers": {
      "payme": "Payme",
      "click": "Click"
    },
    "formats": {
      "offline": "In person",
      "online": "Online"
    },
    "withdrawalCount": "{{count}} withdrawals · {{coffees}} withdrawn",
    "sectionQueueHint": "Work that is waiting. Every row links to the page that handles it.",
    "sectionSummary": "Period results",
    "sectionSummaryHint": "The selected period compared with the previous one.",
    "sectionTrends": "Trend over time",
    "sectionTrendsHint": "How the numbers moved inside the period.",
    "sectionFunnelHint": "From sign-up to a confirmed meeting: where we lose people.",
    "sectionBreakdown": "Composition",
    "sectionBreakdownHint": "What invitations, payments and meetings are made of.",
    "sectionTop": "Leaders",
    "sectionTopHint": "Most active hosts and guests in the period; ratings are all-time.",
    "noAccess": "Nothing to show here",
    "noAccessHint": "You have access to none of the dashboard blocks. Ask an administrator for the section you need."
  },
  "users": {
    "title": "Users",
    "subtitle": "Search, block and assign roles.",
    "name": "Name",
    "telegram": "Telegram",
    "phone": "Phone",
    "status": "Status",
    "balance": "Balance",
    "meetings": "Meetings",
    "registered": "Registered",
    "hostMode": "Host",
    "verified": "Verified",
    "block": "Block",
    "unblock": "Unblock",
    "blockTitle": "Block user",
    "blockReason": "Reason",
    "blockHint": "A blocked user cannot sign in and their invitations are cancelled. Held coffee returns to the guest.",
    "roles": "Roles",
    "statuses": {
      "active": "Active",
      "blocked": "Blocked",
      "deleted": "Deleted"
    },
    "blockReasons": {
      "negative_balance": "Negative balance",
      "abuse": "Rule violation",
      "fraud": "Fraud",
      "admin_decision": "Administrator decision"
    },
    "empty": "No users found",
    "manageRoles": "Roles",
    "lastSeen": "Last seen",
    "loadFailed": "The list did not load",
    "loadFailedHint": "The server did not respond. Refresh the page or try again later.",
    "emptyHint": "Try clearing the filters — no users match.",
    "superadmin": "Superadmin",
    "noRoles": "No roles assigned",
    "profile": "Profile",
    "finance": "Finance",
    "financeForbidden": "No permission to view financial data (ledger.read).",
    "notFound": "User not found",
    "availableBalance": "Available coffee",
    "heldAndMaturing": "Held: {{held}} · Maturing: {{maturing}}",
    "coffeesBought": "Coffee bought",
    "withdrawn": "Withdrawn",
    "coffeesEarned": "From meetings",
    "coffeesSpent": "On meetings",
    "meetingsAsHost": "{{count}} meetings as host",
    "meetingsAsGuest": "{{count}} meetings as guest",
    "net": "Net flow",
    "netHint": "In (bought + earned) minus out (spent + withdrawn).",
    "spentUzs": "{{amount}} UZS paid",
    "receivedUzs": "{{amount}} UZS received",
    "asHost": "As host",
    "asGuest": "As guest",
    "delete": "Delete",
    "deleted": "Account deleted",
    "confirmDelete": "The account is marked as deleted and host mode is switched off. Rows are not removed from the database — the ledger history is kept. This cannot be undone: unblocking does not restore a deleted account.",
    "expiresAt": "Valid until {{date}}",
    "blockDuration": "Duration",
    "blockForever": "Permanent",
    "blockDays": "{{count}} days",
    "blockUntil": "Until {{date}}",
    "blockDurationHint": "A timed block lifts itself. A week is usually enough for a first offence."
  },
  "invitations": {
    "title": "Invitations",
    "subtitle": "Who invited whom, when it was sent, whether it was answered and why.",
    "guest": "Guest",
    "host": "Host",
    "topic": "Topic",
    "coffees": "Coffees",
    "status": "Status",
    "created": "Created",
    "expires": "Expires",
    "empty": "No invitations found",
    "statuses": {
      "pending": "Awaiting reply",
      "accepted": "Accepted",
      "declined": "Declined",
      "slot_taken": "Slot taken",
      "expired": "Expired",
      "cancelled_by_guest": "Cancelled by guest",
      "cancelled_by_host": "Cancelled by host",
      "cancelled_by_admin": "Cancelled by a moderator",
      "confirmed": "Confirmed",
      "disputed": "Disputed",
      "refunded": "Refunded",
      "no_show": "No-show",
      "settled": "Split by moderator"
    },
    "refund": "Manual refund",
    "refundTitle": "Refund the coffee",
    "refundHint": "The coffee returns to the guest and a ledger entry is written. This cannot be undone.",
    "refundAmount": "Refund amount",
    "duration": "Duration",
    "when": "Meeting time",
    "search": "Name or Telegram",
    "sentAt": "Sent",
    "answeredAt": "Answered",
    "declineReason": "Reason",
    "price": "Amount",
    "noAnswer": "No answer",
    "emptyHint": "Widen the filter or pick another date range.",
    "loadFailed": "Couldn't load invitations",
    "loadFailedHint": "The server didn't respond. Try refreshing the page.",
    "format": "Format",
    "formats": {
      "online": "Online",
      "offline": "In person"
    },
    "detailTitle": "Meeting card",
    "detailSubtitle": "The invitation itself, the room log and presence — on one page.",
    "notFound": "Invitation not found",
    "notFoundHint": "The link is stale or the invitation was removed. Go back to the list and search there.",
    "open": "Open",
    "sectionInvitation": "Invitation",
    "sectionRoom": "Online room",
    "roomOfflineHint": "This meeting was in person: no online room was opened, so there is no log.",
    "cancel": "Cancel invitation",
    "cancelHint": "The coffee returns to the guest in full. No late-cancellation compensation is taken — the guest did nothing.",
    "cancelConfirm": "The invitation will be closed and the coffee returned to the guest in full. This cannot be undone.",
    "cancelReason": "Reason",
    "cancelReasonPlaceholder": "For example: the host was blocked, the meeting will not happen",
    "cancelReasonHint": "At least 10 characters. It goes into the audit log and into the note on the coffee entry.",
    "cancelDone": "Invitation cancelled",
    "cancelUnavailable": "An invitation in this state cannot be cancelled. A dispute is resolved from the complaint screen."
  },
  "ledger": {
    "title": "Ledger",
    "subtitle": "Every coffee movement is an immutable record. The only way to settle a dispute.",
    "user": "User",
    "account": "Account",
    "amount": "Coffee",
    "refType": "Reason",
    "refId": "Related record",
    "createdAt": "Time",
    "empty": "No entries found",
    "accounts": {
      "available": "Available",
      "held": "Held",
      "maturing": "Maturing",
      "external": "External"
    },
    "balanceCheck": "Sum check",
    "balanceCheckOk": "All entries sum to zero",
    "balanceCheckFail": "Entries add up to {{value}}, not zero. This is a system error.",
    "note": "Note",
    "inflow": "In",
    "outflow": "Out",
    "netFlow": "Net",
    "external": "External",
    "externalHint": "Ownerless account: where money enters and leaves the system.",
    "balanceOk": "Sum is zero",
    "balanceBroken": "Sum is broken",
    "adjustTitle": "Adjust coffee",
    "adjustHint": "The entry is never deleted — a new one is written on top. The reason stays in the log.",
    "adjustDirection": "Direction",
    "adjust_add": "Add",
    "adjust_remove": "Remove",
    "adjustAmount": "How many coffees",
    "adjustAccount": "Which account",
    "adjustPreview": "Balance:",
    "adjustNegative": "The balance will go negative. That is correct after a reversed payment; otherwise check again.",
    "adjustNote": "Reason",
    "adjustNotePlaceholder": "For example: manual refund for dispute #124, bank document 9912",
    "adjustNoteHint": "At least 10 characters. A month from now this line is the only answer to «why was this done?».",
    "adjustSubmit": "Adjust",
    "adjustDone": "Account adjusted"
  },
  "payments": {
    "title": "Payments",
    "subtitle": "Balance top-ups through Payme and Click.",
    "provider": "Provider",
    "providerTxnId": "Provider ID",
    "amount": "Amount, UZS",
    "coffees": "Coffees",
    "status": "Status",
    "createdAt": "Time",
    "empty": "No payments found",
    "statuses": {
      "pending": "Pending",
      "succeeded": "Succeeded",
      "cancelled": "Cancelled",
      "failed": "Failed"
    },
    "paidAt": "Paid at",
    "succeededCount": "Succeeded",
    "totalAmount": "Amount"
  },
  "withdrawals": {
    "title": "Withdrawals",
    "subtitle": "Requests to turn coffee into money. Coffee leaves the balance when the request is made.",
    "amount": "Amount, UZS",
    "destination": "Card",
    "processedAt": "Processed",
    "createdAt": "Time",
    "empty": "No requests found",
    "statuses": {
      "pending": "Pending",
      "paid": "Paid",
      "rejected": "Rejected"
    },
    "coffees": "Coffee",
    "requestedAt": "Requested at",
    "note": "Note",
    "pendingCount": "Pending",
    "paidAmount": "Paid out",
    "decide": "Decide",
    "decideTitle": "Decision on the payout",
    "decideHint": "Make the bank transfer, then mark it here. Rejecting returns the coffee to the host.",
    "gross": "Gross",
    "tax": "Tax ({{percent}}%)",
    "net": "To the card",
    "markPaid": "Paid",
    "markedPaid": "Payout marked as paid",
    "reject": "Reject",
    "rejected": "Payout rejected, coffee returned",
    "notePlaceholder": "Bank document number or rejection reason",
    "noteHint": "A reason is required when rejecting and is shown to the user.",
    "closedTitle": "Withdrawals are closed (ADR 0025)",
    "closedBody": "Coffee is never cashed out: it is only bought on the platform and spent on meetings. No new requests can appear, and this page is left only for OLD requests still awaiting a decision. Once they are resolved the page stays empty."
  },
  "reports": {
    "title": "Reports",
    "subtitle": "An upheld complaint returns the coffee to the guest and affects the profile. After a second upheld complaint the user is blocked.",
    "reporter": "Reported by",
    "target": "About",
    "reason": "Reason",
    "comment": "Comment",
    "status": "Status",
    "createdAt": "Time",
    "empty": "No reports",
    "queueEmpty": "The queue is empty — nothing waiting for review.",
    "statuses": {
      "open": "Open",
      "reviewing": "Under review",
      "resolved": "Resolved",
      "rejected": "Rejected"
    },
    "resolve": "Mark as resolved",
    "reject": "Mark as unfounded",
    "blockTarget": "Block the profile",
    "review": "Review",
    "meeting": "Meeting",
    "meetingChat": "Chat history",
    "threadReporter": "Reporter",
    "threadTarget": "Other side",
    "threadEmpty": "No question asked yet.",
    "targetWarning": "This person learns about the report ONLY after you write.",
    "moderator": "Moderation",
    "party": "User",
    "ask": "Ask",
    "askPlaceholder": "Ask what happened. The answer affects the decision.",
    "chatEmpty": "No messages for this meeting.",
    "alreadyResolved": "A decision was made — the thread and buttons are closed.",
    "confirmResolve": "Uphold this report?",
    "confirmReject": "Dismiss this report?",
    "moneyToGuest": "{{coffees}} coffee goes back to the guest. If this is the second upheld report against them, they are blocked.",
    "moneyToHost": "The meeting counts as held: {{coffees}} coffee goes to the host.",
    "noMoney": "This decision does not move money — the coffee is already settled. It affects the profile only.",
    "notePlaceholder": "What did you find? The note is visible to moderators only.",
    "coffeeCount": "{{count}} coffee",
    "minuteCount": "{{count}} min",
    "formats": {
      "offline": "In person",
      "online": "Online"
    },
    "reasons": {
      "no_show": "No-show",
      "behavior": "Bad behaviour",
      "spam": "Advertising or spam",
      "fake_profile": "Fake profile",
      "other": "Something else",
      "impersonation": "Impersonation"
    },
    "moneySplit": "The coffee is split: {{host}} to the host, {{guest}} to the guest.",
    "splitLabel": "How much coffee to the host?",
    "splitPlaceholder": "Derive from the decision",
    "splitHint": "Left empty: an upheld report sends everything to the guest, a rejected one everything to the host. In a lateness dispute you set the share yourself.",
    "splitInvalid": "Enter a number between 0 and {{coffees}}.",
    "roomLog": "Join log",
    "roomLogEmpty": "No entries arrived from the LiveKit webhook. This does NOT mean nobody joined: the presence table above comes from the server's own record, and in a dispute that is the reliable source.",
    "roomLogAfter": "{{count}} min after the start",
    "roomLogBefore": "{{count}} min before the start",
    "roomLogServer": "Server",
    "roomKinds": {
      "joined": "joined",
      "left": "left",
      "finished": "room closed"
    },
    "notFound": "Report not found",
    "notFoundHint": "The link may be out of date. Go back to the queue and pick the report from the list.",
    "decision": "Decision",
    "decisionHint": "The decision is final: it affects the profile and, in a disputed meeting, moves the coffees.",
    "noteLabel": "Moderator note",
    "resolveForbidden": "You cannot make a decision here — the evidence is read-only for you.",
    "roomActivity": "Attendance",
    "roomActivityEmpty": "No attendance records.",
    "roomEntries": "Joined {{count}} time(s)",
    "roomTotal": "Total in room: {{time}}",
    "roomOnline": "in the room now",
    "roomGuest": "Guest",
    "roomHost": "Host",
    "roomSessionOpen": "still open",
    "roomActivityHint": "Joins come from the server's own record — visible even when the LiveKit webhook never arrived.",
    "roomLogTitle": "External log (LiveKit)",
    "meetingCard": "Meeting card",
    "meetingEnds": "Ends",
    "meetingConfirmed": "Confirmed",
    "selfPartyHint": "You are a party to this report — you cannot handle your own dispute. Another moderator has to decide it.",
    "redact": "Hide message",
    "restore": "Restore message",
    "redacted": "Hidden by a moderator",
    "redactHint": "The text stops being visible to the parties. Here it is kept in full — a message is evidence in a dispute.",
    "redactConfirm": "The message text stops being visible to the parties. It is not deleted: you can read it here and restore it at any time.",
    "restoreConfirm": "The text returns to the parties.",
    "redactReason": "Reason",
    "redactReasonPlaceholder": "For example: insulting, contains a phone number",
    "redactReasonHint": "At least 10 characters. It goes into the audit log.",
    "redactDone": "Message hidden",
    "restoreDone": "Message restored"
  },
  "hostApplications": {
    "title": "Host applications",
    "subtitle": "Hosting is not a toggle: every new host goes through this queue.",
    "empty": "No applications",
    "queueEmpty": "The queue is empty — nothing to review right now.",
    "review": "Review",
    "statuses": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "banned": "Hosting restricted",
    "bannedHint": "This person is barred from hosting. Approving the application changes nothing — lift the restriction first.",
    "meetingCount": "{{count}} meetings",
    "about": "About",
    "links": "Links",
    "reviewNote": "Admin note",
    "level": "Trust",
    "levels": {
      "1": "1 — unverified",
      "2": "2 — application approved",
      "3": "3 — identity confirmed"
    },
    "meetings": "Meetings",
    "phone": "Phone",
    "registered": "Registered: {{date}}",
    "verifiedTitle": "Identity confirmed",
    "approve": "Approve",
    "reject": "Reject",
    "confirmApprove": "Approve this application?",
    "confirmReject": "Reject this application?",
    "approveHint": "The person may turn on host mode and their trust level rises to 2. The mode is not switched on automatically — they do that themselves.",
    "rejectHint": "The application is returned and they may submit a new one. They will see your note.",
    "notePlaceholder": "Reason. The applicant will read it.",
    "alreadyReviewed": "Decided on {{date}}",
    "verify": "Grant badge",
    "unverify": "Remove badge",
    "verifyHint": "The badge is the platform's guarantee that this is really the person they claim to be. The story in the application can be made up; meetings that ended without complaints were checked by guests.",
    "verifyTooEarly": "Too early: at least {{count}} confirmed meetings is the recommendation. The call is yours.",
    "confirmVerify": "The badge appears on their profile and they are notified.",
    "confirmUnverify": "The badge is removed. When in doubt this is gentler than a block.",
    "ban": "Bar from hosting",
    "unban": "Lift restriction",
    "banHint": "This is NOT an account block and no coffees are taken: the person stays a guest and keeps their balance, they simply cannot return to the catalogue.",
    "confirmBan": "Host mode switches off and cannot be turned back on. Coffees and account status are untouched.",
    "confirmUnban": "The person may host again. Host mode is not switched on automatically.",
    "banNotePlaceholder": "Reason. The user will read it.",
    "applicant": "Applicant",
    "status": "Status",
    "hostBan": "Restriction",
    "submitted": "Submitted",
    "notFound": "Application not found",
    "notFoundHint": "The link is stale or the application was deleted. Go back to the list and look for it in the queue.",
    "applicationSection": "Application",
    "decisionSection": "Decision",
    "tier": "Tier",
    "tiers": {
      "community": "Community",
      "partner": "Partner"
    },
    "tierHint": "A partner is a host the platform invited itself. This is a label, not a payment: coffee is never cashed out to anyone, and no payment logic is tied to this field.",
    "tierToPartner": "Make partner",
    "tierToCommunity": "Back to community",
    "confirmTierPartner": "A «partner» label will appear on the profile. It does not affect the balance or the coffee in any way.",
    "confirmTierCommunity": "The label will be removed. It does not affect the balance or the coffee in any way."
  },
  "settings": {
    "title": "Platform settings",
    "subtitle": "Price, deadlines and limits live in the database — no deploy needed to change them.",
    "dangerHint": "These values affect the whole product immediately. Changing price or commission does not touch invitations already sent: each one freezes its own amount and cancellation terms when it is sent.",
    "readOnlyHint": "You have read access only. Changing these requires `settings.update`.",
    "loadFailed": "Settings failed to load",
    "loadFailedHint": "The server did not answer. Try again — if it keeps failing, check the backend logs.",
    "retry": "Try again",
    "groupMoney": "Money",
    "groupDeadlines": "Deadlines",
    "groupCancel": "Cancellation",
    "groupSchedule": "Schedule",
    "invitationTtl": "Time to answer an invitation",
    "invitationTtlHint": "With no answer in this window the invitation expires and the coffee returns to the guest.",
    "payoutMaturity": "Payout maturity",
    "payoutMaturityHint": "Coffee from a meeting becomes withdrawable after this period. If a complaint arrives within the window, a moderator can split it. It must not exceed the complaint window.",
    "freeCancel": "Free cancellation window",
    "freeCancelHint": "With more than this long until the meeting, the guest cancels without a fee.",
    "lateRefund": "Refund on late cancellation",
    "lateRefundHint": "Past the window the guest gets this share back; the rest stays with the host as compensation.",
    "bookingHorizon": "Booking horizon",
    "bookingHorizonHint": "Slots beyond this are not shown in the catalogue.",
    "minNotice": "Minimum notice",
    "minNoticeHint": "A slot can be booked no later than this before it starts.",
    "range": "{{min}}–{{max}}",
    "percent": "%",
    "hours": "h",
    "days": "days",
    "errInteger": "Enter a whole number",
    "errRange": "Must be between {{min}} and {{max}}",
    "confirmTitle": "This change affects money",
    "confirmBody": "Price and commission apply across the platform immediately. Invitations already sent keep their old values.",
    "confirmLabel": "Save",
    "saved": "Settings saved",
    "buyPrice": "Buying price",
    "buyPriceHint": "Price of 1 coffee. This is what the user's card is charged.",
    "sellPrice": "Withdrawal price",
    "sellPriceHint": "Payout for 1 coffee. This is what reaches the host's card. The gap between the two is the platform's revenue.",
    "errSellAboveBuy": "The withdrawal price cannot be higher than the buying price.",
    "groupChat": "Chat and moderation",
    "reminderHours": "Reminder",
    "reminderHoursHint": "How many hours before the meeting the reminder is sent.",
    "chatOpens": "Chat opens",
    "chatOpensHint": "How many hours before the meeting the chat opens. The two sides never see each other's numbers — the chat is their only channel.",
    "chatCloses": "Chat closes",
    "chatClosesHint": "How many hours after the meeting the chat closes. The history is kept.",
    "reportWindow": "Report window",
    "reportWindowHint": "How many hours after the meeting a report can be filed.",
    "errReportBeforePayout": "The complaint window cannot be shorter than payout maturity: there would be a gap where the coffee is frozen but no complaint can be filed.",
    "errStep": "The value must be a multiple of {{step}}",
    "rangeStep": "{{min}}–{{max}}, step {{step}}"
  },
  "meetingOptions": {
    "title": "Meeting options",
    "subtitle": "Decide which formats and lengths the platform offers.",
    "dangerHint": "The change takes effect IMMEDIATELY. A switched-off option stays visible on public pages but can't be chosen; hosts can't enable it in their profile; a pending invitation CANNOT be accepted — declining or letting it expire returns the coffee to the guest. Meetings already agreed still go ahead: the agreement and the money are locked in.",
    "loadFailed": "Could not load the options",
    "loadFailedHint": "The server did not answer. Try again — if it keeps failing, check the backend logs.",
    "formats": "Formats",
    "durations": "Lengths",
    "format": {
      "offline": "In person",
      "online": "Online"
    },
    "formatHint": {
      "offline": "A face-to-face meeting. The place is agreed in chat.",
      "online": "A meeting over video."
    },
    "disabled": "Disabled",
    "lastEnabled": "The last enabled option — it cannot be turned off.",
    "note": "Why it is off",
    "noteHint": "This text appears on public pages. Leave it empty for the default: “This option is unavailable for now”.",
    "notePlaceholder": "For example: online meetings are paused until October 1",
    "saveNote": "Save",
    "saved": "Saved",
    "add": "Add",
    "added": "Length added",
    "addTitle": "New length",
    "addHint": "A length never changes afterwards: rates and invitations point at it. A wrong one can only be turned off.",
    "minutesLabel": "Length, minutes",
    "minutesHint": "From {{min}} to {{max}}.",
    "toggleDuration": "{{minutes}}-minute meeting",
    "minutes": "{{count}} min",
    "hours": "{{count}} h",
    "remove": "Remove",
    "removed": "Length removed",
    "removeTitle": "Remove the length from the list",
    "removeHint": "This only works for a length nothing uses yet. One with rates or invitations cannot be removed — turn it off instead.",
    "err": {
      "integer": "Enter a whole number.",
      "range": "The value is out of range.",
      "duplicate": "That length already exists.",
      "coffeeRange": "Enter a number between {{min}} and {{max}}."
    },
    "limitsTitle": "Invitation limits",
    "limitsHint": "Set separately for each format: an offline meeting costs the host travel and a venue. This is a FLOOR — a host may charge more. Online, a longer meeting must not get cheaper per minute: the 30-minute floor is at least twice the 15-minute one.",
    "minCoffeesLabel": "Minimum coffees",
    "coffees": "coffees",
    "coffeesFrom": "coffees or more",
    "limitAria": "{{duration}}, {{format}}: {{field}}",
    "limitAriaNew": "{{format}}: {{field}}"
  },
  "table": {
    "rowsPerPage": "Per page",
    "of": "of",
    "page": "Page",
    "first": "First",
    "previous": "Previous",
    "next": "Next",
    "last": "Last",
    "noResults": "No results",
    "columns": "Columns",
    "total": "Total: {{count}}",
    "sort": "Sort",
    "sortAsc": "Ascending",
    "sortDesc": "Descending",
    "onThisPage": "On this page",
    "clearFilters": "Clear filters",
    "records": "{{count}} records",
    "loadFailed": "Could not load the list",
    "loadFailedHint": "The server did not respond. Refresh the page or try again later.",
    "emptyFiltered": "Clear the filter — no matching records."
  },
  "errors": {
    "BELOW_HOST_MINIMUM": "Below the host's minimum rate.",
    "BROADCAST_NOT_LIVE": "This broadcast is not live right now.",
    "BROADCAST_NOT_READY": "The broadcast could not start: no watch link, or it has not been published.",
    "CANCELLATION_WINDOW_CLOSED": "The meeting has started — it cannot be cancelled.",
    "CHAT_CLOSED": "The chat is closed.",
    "CHAT_NOT_AVAILABLE": "There is no chat for this invitation.",
    "CONFIRMATION_ALREADY_USED": "This code has already been used.",
    "CONFIRMATION_CODE_EXPIRED": "The confirmation code has expired.",
    "CONFIRMATION_CODE_INVALID": "The confirmation code is wrong.",
    "CONFIRMATION_LOCKED": "Too many wrong attempts — code entry is temporarily locked.",
    "CONFIRMATION_NOT_APPLICABLE": "An online meeting is not confirmed with a code — the system settles it from the join log.",
    "CONFIRMATION_TOO_EARLY": "The meeting has not started yet.",
    "DISPUTE_CLOSED": "The dispute conversation is closed.",
    "DISPUTE_SELF_PARTY": "You are a party to this report: you cannot handle your own dispute.",
    "DUPLICATE_TRANSACTION": "This transaction has already been recorded.",
    "DURATION_DISABLED": "That length is switched off right now.",
    "DURATION_NOT_OFFERED": "This host doesn't offer meetings of that length.",
    "FORBIDDEN": "You don't have permission for this action.",
    "FORMAT_DISABLED": "That format is switched off right now.",
    "FORMAT_NOT_OFFERED": "The host does not offer this format.",
    "HOST_APPLICATION_ALREADY_REVIEWED": "The application has already been reviewed — refresh the page.",
    "HOST_APPLICATION_EXISTS": "This user already has an application under review.",
    "HOST_APPLICATION_NOT_FOUND": "Application not found.",
    "HOST_APPLICATION_REQUIRED": "An application is required first.",
    "HOST_BANNED": "Host mode is restricted for this user.",
    "HOST_UNAVAILABLE": "This host isn't accepting invitations.",
    "INSUFFICIENT_BALANCE": "Not enough coffee: {{required}} needed, {{available}} available.",
    "INTERNAL_ERROR": "Server error. We'll fix it shortly.",
    "INVALID_STATE_TRANSITION": "That action isn't available in the current state. Refresh the page.",
    "INVITATION_ALREADY_SENT": "An invitation for this time has already been sent.",
    "INVITATION_NOT_FOUND": "Invitation not found.",
    "INVITE_CODE_REQUIRED": "Closed beta: an invite code is required to send invitations.",
    "LEDGER_IMBALANCE": "An accounting discrepancy. This is a systemic error — investigate immediately.",
    "NETWORK_ERROR": "Couldn't reach the server. Check your connection.",
    "NOT_A_SPEAKER": "This person is not a speaker in the broadcast.",
    "NOT_FOUND": "The requested data was not found.",
    "NO_AVAILABILITY_CONFIGURED": "This host hasn't set a schedule.",
    "PAYLOAD_TOO_LARGE": "That file is too large.",
    "PAYMENT_FAILED": "The payment failed.",
    "PAYMENT_PROVIDER_DISABLED": "The payment system is temporarily unavailable. Please try again shortly.",
    "PAYOUT_PROFILE_LOCKED": "An approved profile cannot be changed.",
    "PAYOUT_PROFILE_REQUIRED": "An approved payout profile is required.",
    "PROFILE_INCOMPLETE": "The profile is incomplete.",
    "PROMO_BUDGET_EXHAUSTED": "The bonus budget for this month is used up. You can raise it in settings.",
    "PROMO_CODE_NOT_FOUND": "No such promo code.",
    "PROMO_CODE_UNAVAILABLE": "The code is not usable right now: disabled, expired or used up.",
    "RATE_LIMITED": "Too many requests. Please wait a moment.",
    "REPORT_ALREADY_EXISTS": "A complaint about this meeting already exists.",
    "REPORT_ALREADY_RESOLVED": "The complaint is already resolved — refresh the page.",
    "REPORT_NOT_ALLOWED": "A complaint cannot be filed for this meeting.",
    "REPORT_NOT_FOUND": "Complaint not found.",
    "REVIEW_ALREADY_EXISTS": "A rating has already been left.",
    "REVIEW_NOT_ALLOWED": "This meeting cannot be rated.",
    "ROOM_CLOSED": "The room is closed.",
    "ROOM_NOT_AVAILABLE": "This meeting has no online room.",
    "ROOM_PARTICIPANT_PRESENT": "The other person is already in the room.",
    "ROOM_SERVER_UNAVAILABLE": "The video server is not responding right now.",
    "SELF_INVITATION": "You cannot invite yourself.",
    "SESSION_REVOKED": "The session was closed. Please sign in again.",
    "SLOT_ALREADY_TAKEN": "That time is already taken.",
    "SLOT_NOT_AVAILABLE": "That time isn't in the host's schedule.",
    "SPEAKER_NOT_HOST": "A speaker must be an active host.",
    "TELEGRAM_PHOTO_NOT_FOUND": "No profile photo found on Telegram.",
    "TOKEN_EXPIRED": "Your session expired. Sign in again.",
    "TOKEN_INVALID": "Your session is invalid. Sign in again.",
    "UNAUTHORIZED": "You need to sign in.",
    "UNKNOWN": "Something unexpected went wrong. Please try again.",
    "USER_BLOCKED": "This user is blocked.",
    "USER_NOT_FOUND": "User not found.",
    "VALIDATION_FAILED": "The data is invalid. Check the form.",
    "WITHDRAWALS_DISABLED": "Coffee cannot be cashed out. It can only be spent on meetings.",
    "WITHDRAWAL_BELOW_MINIMUM": "The withdrawal is below the minimum.",
    "WITHDRAWAL_NOT_PENDING": "This payout has already been processed."
  },
  "notFound": {
    "title": "Page not found",
    "body": "The link is out of date, or the address was mistyped.",
    "cta": "Go to the dashboard"
  },
  "errorPage": {
    "title": "Something went wrong",
    "body": "The error has been logged. Try refreshing the page.",
    "retry": "Try again",
    "staleTitle": "The panel was updated",
    "staleBody": "You are looking at an older copy of the panel. Reload the page — open work is not lost.",
    "staleRetry": "Reload the page"
  },
  "roles": {
    "title": "Roles and permissions",
    "subtitle": "A role is a name for a set of permissions. Create as many as you like: the code never looks at role names, every action is checked by permission.",
    "create": "Create role",
    "createTitle": "New role",
    "editTitle": "Edit role",
    "formHint": "Tick permissions by section or one by one. The list comes from the backend and is read-only.",
    "code": "Code",
    "codeHint": "Lowercase letters, digits and _. Fixed once created.",
    "name": "Name",
    "description": "Description",
    "permissions": "Permissions",
    "selectedCount": "{{count}} selected",
    "permissionCount": "{{count}} permissions",
    "system": "System role",
    "empty": "No roles yet",
    "emptyHint": "Create the first role and assign it to people. A superadmin has full access without any role.",
    "deleted": "Role deleted",
    "deleteTitle": "Delete this role?",
    "deleteHint": "The role “{{name}}” will be deleted and removed from everyone who has it. They lose the permissions it granted immediately.",
    "assigned": "Roles saved",
    "assignTitle": "Assign roles",
    "assignHint": "Choose roles for {{name}}. Permissions are the union of the selected roles.",
    "groups": {
      "dashboard": "Dashboard",
      "users": "Users",
      "roles": "Roles",
      "hosts": "Hosts",
      "invitations": "Invitations",
      "ledger": "Ledger",
      "payments": "Payments",
      "reports": "Reports",
      "reference": "Reference data",
      "settings": "Settings",
      "audit": "Audit log",
      "analytics": "Analytics",
      "sidebar": "Sidebar"
    },
    "created": "Role created",
    "updated": "Role saved",
    "notFound": "Role not found",
    "notFoundHint": "The link is stale or the role was deleted. Go back to the list and pick it again.",
    "readOnly": "Read-only: you cannot change this role.",
    "selectGroup": "All permissions in “{{group}}”",
    "groupSelected": "{{selected}}/{{total}}",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "errors": {
      "nameMin": "The name needs at least 2 characters",
      "codeFormat": "Starts with a lowercase letter; letters, digits and _"
    }
  },
  "analytics": {
    "title": "Analytics",
    "subtitle": "Visits, pages and funnel — from our own data. Yandex Metrica lives in its own panel: it answers “where they came from”, this page answers “what they did”.",
    "views": "Page views",
    "visitors": "Unique visitors",
    "identified": "Signed-in users",
    "traffic": "Daily traffic",
    "topPages": "Most viewed pages",
    "topReferrers": "Traffic sources",
    "events": "Events",
    "empty": "No data for this period",
    "emptyHint": "Events start arriving once the site is opened. Check that NEXT_PUBLIC_ANALYTICS_URL is set on the frontend.",
    "noReferrers": "Visits with no source: the address was typed directly or the link came through a messenger."
  },
  "reference": {
    "title": "Reference data",
    "subtitle": "Industries, regions and districts. Changes here show up immediately in every form and filter on the site.",
    "create": {
      "industries": "Add industry",
      "regions": "Add region",
      "districts": "Add district"
    },
    "editTitle": "Edit entry",
    "formHint": "The name is required in all three languages — otherwise that language shows the raw code.",
    "code": "Code",
    "codeHint": "Lowercase letters, digits and hyphens only. It never changes after creation.",
    "name": {
      "uz": "Name (uz)",
      "ru": "Name (ru)",
      "en": "Name (en)"
    },
    "sortOrder": "Order",
    "status": "Status",
    "active": "Active",
    "inactive": "Disabled",
    "region": "Region",
    "regionHint": "The region cannot be changed after creation.",
    "type": "Type",
    "typeDistrict": "District",
    "typeCity": "City",
    "count": "{{count}} entries",
    "empty": "Nothing here yet",
    "emptyHint": "Add the first entry.",
    "saved": "Saved",
    "titles": {
      "industries": "Industries",
      "regions": "Regions",
      "districts": "Districts"
    },
    "subtitles": {
      "industries": "The industry list used by the profile form. Changes reach every form and filter on the site immediately.",
      "regions": "The list of regions. Districts are attached to it.",
      "districts": "Districts and district-level cities. Each belongs to one region."
    },
    "allRegions": "All regions",
    "loadFailed": "The list did not load",
    "loadFailedHint": "The server did not respond. Refresh the page or try again later."
  },
  "activity": {
    "title": "Activity",
    "time": "Time",
    "action": "Action",
    "actor": "Actor",
    "changes": "Changes",
    "ip": "IP",
    "self": "Self",
    "system": "System",
    "more": "{{count}} more",
    "empty": "No activity yet"
  },
  "devices": {
    "title": "Devices",
    "device": "Device",
    "startedAt": "Signed in",
    "lastUsed": "Last active",
    "revoke": "Revoke",
    "revoked": "Session revoked",
    "unknown": "Unknown device",
    "empty": "No active sessions"
  },
  "audit": {
    "title": "Audit log",
    "subtitle": "Who did what, and when — across the whole platform.",
    "empty": "No records found",
    "entity": "Entity",
    "from": "From date",
    "to": "To date",
    "actorRole": "Role",
    "requestId": "Request ID",
    "userAgent": "Device",
    "before": "Before",
    "after": "After",
    "noPayload": "Nothing recorded"
  },
  "adminNotifications": {
    "title": "Queue",
    "empty": "Nothing new. Queue events show up here: applications, reports and money movements.",
    "unread": "{{count}} new",
    "markRead": "Mark as read",
    "clear": "Clear",
    "sessionOnly": "This list lives in this tab only: a reload clears it, while the queue itself stays on its own page.",
    "types": {
      "host_application_submitted": "New host application",
      "report_submitted": "New report",
      "withdrawal_created": "Withdrawal request",
      "payment_succeeded": "New payment"
    }
  },
  "promo": {
    "title": "Promo codes",
    "subtitle": "Bonus coffees, invite codes and campaigns. When a host withdraws bonus coffee the platform pays real money — this is a marketing cost.",
    "create": "New code",
    "createTitle": "New promo code",
    "createHint": "The code is stored in uppercase. How a person types it does not matter.",
    "editTitle": "Edit code",
    "editHint": "The code itself and the coffee amount do not change — they are a promise already handed out. You can stop the campaign or extend it.",
    "edit": "Edit",
    "saved": "Saved",
    "created": "Code created",
    "empty": "No codes yet",
    "emptyHint": "Create the first code and hand it out through your hosts.",
    "loadFailed": "Could not load the list",
    "loadFailedHint": "Try refreshing the page.",
    "coffees": "{{count}} coffees",
    "noCoffees": "No coffee",
    "noDeadline": "No deadline",
    "usedUnlimited": "{{used}} times",
    "columns": {
      "code": "Code",
      "coffees": "Gives",
      "uses": "Used",
      "endsAt": "Ends",
      "state": "State"
    },
    "kind": {
      "invite": "Invite"
    },
    "state": {
      "active": "Active",
      "disabled": "Disabled",
      "exhausted": "Used up",
      "expired": "Expired"
    },
    "fields": {
      "code": "Code",
      "coffees": "How many coffees",
      "coffeesHint": "0 — gives no coffee. Normal for an invite code: it only opens the right.",
      "invite": "Invite code",
      "inviteHint": "Opens the right to send invitations during the closed beta.",
      "maxUses": "Total uses",
      "maxUsesPlaceholder": "Empty — unlimited",
      "endsAt": "Until",
      "note": "Note",
      "notePlaceholder": "Which campaign, who asked",
      "enabled": "Active",
      "enabledHint": "Turning this off stops the code immediately. Bonuses already granted stay."
    }
  },
  "live": {
    "title": "Live broadcasts",
    "subtitle": "Qahvadosh Live: the stream goes out on YouTube, the Q&A stays on our site.",
    "create": "New broadcast",
    "createTitle": "New broadcast",
    "editTitle": "Edit broadcast",
    "formHint": "Saved as a DRAFT — nobody sees it until you publish.",
    "empty": "No broadcasts yet.",
    "loadFailed": "Could not load the broadcast list.",
    "fieldTitle": "Title",
    "fieldDescription": "Description",
    "fieldScheduledAt": "Time",
    "fieldSlug": "Link",
    "slugPlaceholder": "generated from the title",
    "slugHint": "Leave empty to generate from the title. If taken, a number is appended.",
    "slugLocked": "A published broadcast keeps its link — it may already be circulating.",
    "fieldWatchUrl": "Watch link",
    "watchUrlHint": "A YouTube link. REQUIRED to go live — without it the page has no player.",
    "fieldSpeakers": "Speakers",
    "addSpeaker": "Add a speaker",
    "removeSpeaker": "Remove speaker",
    "rolePlaceholder": "Role",
    "noSpeakers": "No active hosts found. A speaker must be a host.",
    "publish": "Publish",
    "cancel": "Cancel",
    "start": "Go live",
    "stop": "End",
    "startBlocked": "A watch link is required to go live.",
    "rtmpLabel": "RTMP targets",
    "rtmpPlaceholder": "rtmp://... (optional)",
    "started": "Broadcast started, notifications sent",
    "stopped": "Broadcast ended",
    "startFailed": "Could not start the broadcast",
    "stopFailed": "Could not end the broadcast",
    "statusChanged": "Status changed",
    "statusFailed": "Could not change the status",
    "created": "Broadcast created",
    "updated": "Broadcast saved",
    "saveFailed": "Could not save the broadcast",
    "reminderCount": "{{count}} reminders",
    "questionCount": "{{count}} questions",
    "questionsTitle": "Questions",
    "noQuestions": "No questions yet.",
    "markAnswered": "Answered",
    "hide": "Hide",
    "unhide": "Restore",
    "questionFailed": "Could not change the question status",
    "statusAnswered": "Answered",
    "statusHidden": "Hidden",
    "status": {
      "draft": "Draft",
      "scheduled": "Published",
      "live": "Live",
      "ended": "Ended",
      "canceled": "Canceled"
    }
  },
  "payouts": {
    "title": "Payout profiles",
    "subtitle": "Before withdrawing, a host confirms who they are and their tax status. Approving opens payouts for them.",
    "tabs": {
      "pending": "In queue",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "status": {
      "individual": "Individual",
      "sole_trader": "Sole trader",
      "legal_entity": "Legal entity"
    },
    "empty": {
      "pending": "The queue is empty",
      "approved": "No approved profiles",
      "rejected": "No rejected profiles"
    },
    "account": "Account: {{name}}",
    "pinfl": "PINFL •••• {{last4}}",
    "noPinfl": "No PINFL given",
    "tin": "Tax ID {{tin}}",
    "review": "Review",
    "reviewTitle": "Decision on the profile",
    "effect": {
      "individual": "{{name}} — individual. Approving opens payouts, and income tax will be withheld from each one.",
      "sole_trader": "{{name}} — sole trader. Approving opens payouts, and the FULL amount will be transferred.",
      "legal_entity": "{{name}} — legal entity. Approving opens payouts, and the FULL amount will be transferred."
    },
    "fields": {
      "account": "Account",
      "fullName": "Full name",
      "pinfl": "PINFL",
      "tin": "Tax ID",
      "note": "Note"
    },
    "notePlaceholder": "A reason is required when rejecting",
    "noteHint": "The rejection reason is shown to the user — write what to fix.",
    "approve": "Approve",
    "reject": "Reject",
    "approved": "Profile approved",
    "rejected": "Profile rejected",
    "closedTitle": "New profiles are not accepted (ADR 0025)",
    "closedBody": "Withdrawals are closed, so the tax profile has no purpose left: a new one cannot be submitted. Existing records stay as moderation history; the PINFL has been cleared by a migration."
  },
  "reviews": {
    "title": "Reviews",
    "subtitle": "Comments left after meetings. A review that breaks the rules is hidden — never deleted.",
    "search": "Search",
    "searchPlaceholder": "Review text or a name",
    "filter": "State",
    "filterAll": "All",
    "filterVisible": "Visible",
    "filterHidden": "Hidden",
    "empty": "No reviews found",
    "emptyHint": "Widen the filter or change the search.",
    "isHidden": "Hidden",
    "hiddenBecause": "Reason: {{reason}}",
    "hide": "Hide",
    "show": "Restore",
    "hidden": "Review hidden",
    "shown": "Review restored",
    "hideConfirm": "The review disappears from the public page and leaves the host's rating. It is not deleted — you can restore it at any time.",
    "showConfirm": "The review returns to the public page and counts towards the rating again.",
    "reason": "Reason",
    "reasonPlaceholder": "For example: insulting, not about the meeting",
    "reasonHint": "At least 10 characters. It goes into the audit log and is shown next to the review."
  },
  "messages": {
    "title": "Messages and announcements",
    "subtitle": "Write to a user or announce something to everyone. The message appears on the site and in Telegram.",
    "announceTitle": "New announcement",
    "audience": "Audience",
    "audienceAll": "Everyone",
    "audienceHosts": "Hosts only",
    "text": "Text",
    "textPlaceholder": "For example: the site will be down for maintenance on 20 September, 02:00–04:00.",
    "textHint": "The text is NOT TRANSLATED — the user sees it exactly as written. Between 10 and 1000 characters.",
    "send": "Send",
    "confirmTitle": "Send the announcement",
    "confirmHint": "The message reaches thousands of phones and CANNOT BE UNDONE. Read the text one more time.",
    "announceDone": "Sent to {{count}} users",
    "filterAll": "All",
    "filterAnnouncements": "Announcements",
    "filterPersonal": "Personal",
    "types": {
      "admin_message": "Personal",
      "admin_announcement": "Announcement"
    },
    "reach": "{{read}} of {{total}} read it",
    "empty": "No messages yet",
    "emptyHint": "Use the form above, or write personally from a user's card.",
    "emptyHintRead": "Sent messages will appear here.",
    "toUser": "Write a message",
    "toUserHint": "The message goes to the site notifications and (if Telegram is linked) to the bot.",
    "toUserDone": "Message sent"
  }
}
